module.exports = __webpack_public_path__ + "static/media/ocean-h.2e822aae.jpg";